// ========================================
// COMPOSANT ProtectedRoute
// Protection des routes admin
// ========================================

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAdminAuth from '../../hooks/useAdminAuth';
import { FiLoader } from 'react-icons/fi';

const ProtectedRoute = () => {
  const { user, loading, isAdmin } = useAdminAuth();
  const location = useLocation();

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <FiLoader className="loading-spinner" />
          <p>Chargement...</p>
        </div>
        
        <style>{`
          .loading-screen {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: var(--color-gray-100);
          }
          
          .loading-content {
            text-align: center;
            color: var(--color-gray-600);
          }
          
          .loading-spinner {
            font-size: 2.5rem;
            color: var(--color-primary);
            animation: spin 1s linear infinite;
            margin-bottom: 1rem;
          }
          
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Si non connecté, rediriger vers l'accueil
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si connecté mais pas admin, rediriger
  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }

  // Si tout est OK, afficher le contenu
  return <Outlet />;
};

export default ProtectedRoute;